import { regionalText } from '@/lib/regional-copy'
/**
 * Who each purchasable plan is for, in one line.
 *
 * Clinicians choosing a plan kept asking "what's the difference between Clinic
 * and Scribe?" (2026-09-23): the cards listed features but never said who each
 * plan suits. These lines are the landing page's (clarohealth.app pricing
 * section) word for word, so a clinician who read the pricing page meets the
 * same sentence in the app. Change them together.
 */
const PLAN_AUDIENCE: Record<string, string> = {
  scribe: 'For a solo practitioner who wants the notes handled.',
  get clinic() { return regionalText('For a clinic that wants to run on one system instead of five.') },
}

export function planAudience(slug: string): string | null {
  return PLAN_AUDIENCE[slug] ?? null
}
